import React, { useState, useEffect } from 'react';
import lodash from 'lodash';
import { Link, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { loginError, setLoginEmailError, setPasswordResetEmailSent, showPasswordInput, ssoSettingPin } from '../../actions/login';
import LoginLayout from './LoginLayout';
import styles from './Login.scss';
import PasswordValidation from './PasswordValidation';

const EMAIL_ADDRESS_PATTERN = /^[a-zA-Z0-9'._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const LoginV4 = (props) => {
    const { showPasswordInput, setLoginEmailError, onLogin, loginErrorState, loginError, setPasswordResetEmailSent, loginShowExpirePassword, router } = props;

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [passwordType, setPasswordType] = useState(true);
    const [showSignaturePinSSO, setShowSingnaturePinSSO] = useState(false);
    const [validPassword, setValidPassword] = useState(false);

    useEffect(() => {
        setPasswordResetEmailSent(false);
        showPasswordInput(false);
    }, [showPasswordInput]);

    useEffect(() => {
        if (loginShowExpirePassword && email)
            router.push({ pathname: '/expired-password', state: { email } });
    }, [loginShowExpirePassword]);

    useEffect(() => {
        if (props.searchParms) {
            const searchParms = props.searchParms;
            if (searchParms.ssouser) {
                setShowSingnaturePinSSO(true);
                setEmail(searchParms.email);
                props.showPasswordInput(true);
                searchParms.error && loginError(searchParms.error);
            }
        }
    }, [props.searchParms]);

    const onSubmitClick = async (e) => {
        e.preventDefault();

        if (!emailMatchesExpectedPattern()) {
            setLoginEmailError('Please enter a valid email address.');
            return;
        }

        if (!props.showPassword) {
            await onLogin(e, { email }, true);
        } else if (password) {
            setPasswordError('');
            if (showSignaturePinSSO) {
                if (validPassword)
                    props.ssoSettingPin({ email, password });
            }
            else
                onLogin(e, { email, password });
        }
        else {
            setPasswordError('Please enter a valid password.');
        }
    };

    const emailMatchesExpectedPattern = () => {
        return EMAIL_ADDRESS_PATTERN.test(email);
    };

    const togglePasswordVisibility = () => {
        setPasswordType(!passwordType);
    };



    return (
        <LoginLayout>
            <div className={styles.complionTitle}>
                {showSignaturePinSSO ? 'Enter a password to be used during this session for e-signing' : 'A leading eRegulatory platform from RealTime eClinical Solutions.'}
            </div>

            <form autoComplete="off" className={styles.form} onSubmit={(e) => onSubmitClick(e)} noValidate>
                <div className={styles.inputContainer}>
                    <div className={styles.formGroup}>
                        <div className={styles.labelGroup}>
                            <label htmlFor="email" className={styles.inputLabelv4}>
                                Email Address
                            </label>
                        </div>

                        <input
                            id="email"
                            className={`${styles.inputv4} ${props.loginEmailError && styles.inputErrorv4}`}
                            type="text"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoFocus
                            readOnly={showSignaturePinSSO}
                        />
                        {props.loginEmailError && <span className={styles.errorv4}>{props.loginEmailError} </span>}
                    </div>

                    {props.showPassword || showSignaturePinSSO ? (
                        <div className={styles.formGroup}>
                            <div className={styles.labelGroup}>
                                <label htmlFor="password" className={styles.inputLabelv4}>
                                    {showSignaturePinSSO ? 'E-Signature Password' : 'Password'}
                                </label>
                            </div>
                            <label className={`${styles.passowordInput} ${passwordError && styles.passowordInputError}`}>
                                <input
                                    id="password"
                                    type={passwordType ? 'password' : 'text'}
                                    name="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    autoFocus
                                />
                                <FontAwesomeIcon
                                    icon={passwordType ? faEye : faEyeSlash}
                                    className={styles.passwordIcon}
                                    onClick={togglePasswordVisibility}
                                />
                            </label>
                            {passwordError && <span className={styles.errorv4}>{passwordError}</span>}
                            {!showSignaturePinSSO && <div> <Link to={{ pathname: '/forgot-password', state: { email } }} className={styles.forgotPasswordV4}>Forgot Password?</Link></div>}
                            {showSignaturePinSSO &&
                                <PasswordValidation password={password} setValidPassword={setValidPassword} />}
                        </div>
                    ) : null}
                </div>
                {loginErrorState && <span className={styles.errorv4}>{loginErrorState}</span>}

                <div className={styles.formGroup}>
                    <button type="submit" className={styles.actionButtonv4} >
                        {props.showPassword ? 'Sign In' : 'Next'}
                    </button>
                </div>
            </form >
        </LoginLayout >
    );
};

const mapStateToProps = (state, props) => ({
    clientData: lodash.get(state, 'application.config', {}),
    loginErrorState: lodash.get(state, 'loginError', false),
    loginEmailError: lodash.get(state, 'loginEmailError', false),
    showPassword: lodash.get(state, 'showPassword', false),
    loginShowExpirePassword: lodash.get(state, 'showExpiredPassword', false),
});

export default connect(mapStateToProps, { setLoginEmailError, showPasswordInput, ssoSettingPin, loginError, setPasswordResetEmailSent, })(withRouter(LoginV4));
